/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'
import { defineMessages } from 'react-intl'

import { useGeneratedHtmlId, EuiConfirmModal } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

type Props = {
  isLoading: boolean
  onClose: () => void
  onSave: () => void
}

const messages = defineMessages({
  confirmModalTitle: {
    id: 'resource-tags.confirm-modal-title',
    defaultMessage: 'Save pending changes?',
  },
  confirmMessage: {
    id: 'resource-tags.flyout.confirm-message',
    defaultMessage: 'Some changes have not been saved and will be lost.',
  },
  cancelButtonText: {
    id: 'resource-tags.confirm-modal-cancel-button',
    defaultMessage: 'Cancel',
  },
  confirmButtonText: {
    id: 'resource-tags.confirm-modal-save-button',
    defaultMessage: 'Save',
  },
})

const SavePendingChangesModal = ({ isLoading, onClose, onSave }: Props) => {
  const modalTitleId = useGeneratedHtmlId({ prefix: 'changesNotSavedModal' })

  return (
    <EuiConfirmModal
      data-test-id='resource-tags.confirm-modal'
      title={<FormattedMessage {...messages.confirmModalTitle} />}
      onCancel={onClose}
      onConfirm={onSave}
      cancelButtonText={<FormattedMessage {...messages.cancelButtonText} />}
      confirmButtonText={<FormattedMessage {...messages.confirmButtonText} />}
      defaultFocusedButton='confirm'
      isLoading={isLoading}
      aria-labelledby={modalTitleId}
    >
      <FormattedMessage {...messages.confirmMessage} />
    </EuiConfirmModal>
  )
}

export default SavePendingChangesModal
